function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_18_20461)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 17.4141,
  y: 22.8672,
  width: 7.51302,
  height: 12.2086,
  rx: 3.75651,
  transform: "rotate(-45 17.4141 22.8672)",
  fill: "url(#paint0_linear_18_20461)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.4141,
  y: 22.8672,
  width: 7.51302,
  height: 12.2086,
  rx: 3.75651,
  transform: "rotate(-45 17.4141 22.8672)",
  fill: "url(#paint1_linear_18_20461)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.4141,
  y: 22.8672,
  width: 7.51302,
  height: 12.2086,
  rx: 3.75651,
  transform: "rotate(-45 17.4141 22.8672)",
  fill: "url(#paint2_linear_18_20461)"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4141,
  y: 22.8672,
  width: 7.51302,
  height: 12.2086,
  rx: 3.75651,
  transform: "rotate(-45 17.4141 22.8672)",
  fill: "url(#paint3_radial_18_20461)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9062 23.7969C18.8778 23.7969 23.7188 18.956 23.7188 12.9844C23.7188 7.01279 18.8778 2.17188 12.9062 2.17188C6.93466 2.17188 2.09375 7.01279 2.09375 12.9844C2.09375 18.956 6.93466 23.7969 12.9062 23.7969ZM12.9062 22.0469C17.9113 22.0469 21.9688 17.9894 21.9688 12.9844C21.9688 7.97931 17.9113 3.92188 12.9062 3.92188C7.90118 3.92188 3.84375 7.97931 3.84375 12.9844C3.84375 17.9894 7.90118 22.0469 12.9062 22.0469Z",
  fill: "url(#paint4_linear_18_20461)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_18_20461)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9062 23.5523C18.7428 23.5523 23.4742 18.8209 23.4742 12.9844C23.4742 7.14782 18.7428 2.41638 12.9062 2.41638C7.06969 2.41638 2.33826 7.14782 2.33826 12.9844C2.33826 18.8209 7.06969 23.5523 12.9062 23.5523ZM12.9062 21.8419C17.7981 21.8419 21.7638 17.8762 21.7638 12.9844C21.7638 8.09248 17.7981 4.12681 12.9062 4.12681C8.01436 4.12681 4.04868 8.09248 4.04868 12.9844C4.04868 17.8762 8.01436 21.8419 12.9062 21.8419Z",
  fill: "url(#paint5_linear_18_20461)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9062 23.5523C18.7428 23.5523 23.4742 18.8209 23.4742 12.9844C23.4742 7.14782 18.7428 2.41638 12.9062 2.41638C7.06969 2.41638 2.33826 7.14782 2.33826 12.9844C2.33826 18.8209 7.06969 23.5523 12.9062 23.5523ZM12.9062 21.8419C17.7981 21.8419 21.7638 17.8762 21.7638 12.9844C21.7638 8.09248 17.7981 4.12681 12.9062 4.12681C8.01436 4.12681 4.04868 8.09248 4.04868 12.9844C4.04868 17.8762 8.01436 21.8419 12.9062 21.8419Z",
  fill: "url(#paint6_radial_18_20461)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_18_20461)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.9063,
  cy: 12.9844,
  r: 9.29505,
  fill: "url(#paint7_linear_18_20461)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_ii_18_20461)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.9062,
  cy: 12.9844,
  r: 9.0625,
  fill: "#64D0EA"
}));

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.9896,
  cy: 8.44251,
  rx: 1.65124,
  ry: 2.03343,
  transform: "rotate(-38.8957 16.9896 8.44251)",
  fill: "url(#paint8_linear_18_20461)"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_18_20461",
  x: 17.9701,
  y: 18.8607,
  width: 11.8333,
  height: 12.0833,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.4 0 0 0 0 0.239216 0 0 0 0 0.439216 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_20461"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.639216 0 0 0 0 0.490196 0 0 0 0 0.643137 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_20461",
  result: "effect2_innerShadow_18_20461"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.333333 0 0 0 0 0.27451 0 0 0 0 0.380392 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_20461",
  result: "effect3_innerShadow_18_20461"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_18_20461",
  x: 2.03826,
  y: 2.11638,
  width: 21.736,
  height: 21.736,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_18_20461"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_18_20461",
  x: 3.41121,
  y: 3.48933,
  width: 18.9901,
  height: 18.9901,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_18_20461"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_ii_18_20461",
  x: 3.84375,
  y: 3.77187,
  width: 18.125,
  height: 19.275,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.168627 0 0 0 0 0.603922 0 0 0 0 0.956863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_20461"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.137255 0 0 0 0 0.607843 0 0 0 0 0.984314 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_20461",
  result: "effect2_innerShadow_18_20461"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_20461",
  x1: 18.0438,
  y1: 33.2307,
  x2: 22.3749,
  y2: 24.7012,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0659C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#895792"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_20461",
  x1: 21.1595,
  y1: 23.3975,
  x2: 21.1706,
  y2: 27.6844,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C3B74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#845590",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18_20461",
  x1: 25.0265,
  y1: 31.1978,
  x2: 19.8779,
  y2: 31.0431,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.115168,
  stopColor: "#703D7A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#703D7A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_18_20461",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.2148 22.6794) rotate(92.4424) scale(2.33336 5.42286)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F1A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#532D64",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_20461",
  x1: 12.9062,
  y1: 2.17187,
  x2: 12.9063,
  y2: 23.7969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.378529,
  stopColor: "#344A7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.633316,
  stopColor: "#785790"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.837142,
  stopColor: "#785790"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9872A2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_18_20461",
  x1: 12.9062,
  y1: 2.41638,
  x2: 12.9062,
  y2: 23.5523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#475890"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7A4D87"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_18_20461",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.9062 7.40622) rotate(-90.0001) scale(5.125 9.53123)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.704268,
  stopColor: "#566298"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786585,
  stopColor: "#566298",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_20461",
  x1: 12.9063,
  y1: 3.68933,
  x2: 12.9063,
  y2: 22.2794,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#204083"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#523573"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_18_20461",
  x1: 16.9896,
  y1: 6.40908,
  x2: 16.9896,
  y2: 10.4759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDBF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.209118,
  stopColor: "#DCDBF2",
  stopOpacity: 0.84797
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DCDBF2",
  stopOpacity: 0
})));

function SvgMagnifyingGlassTiltedLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassTiltedLeft);
export default __webpack_public_path__ + "static/media/magnifying-glass-tilted-left.3a129244.svg";
export { ForwardRef as ReactComponent };